
document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.classList.contains('single-district-resource')) {
        return;
    }
    let downloadLinks = document.querySelectorAll('.district-resources-download a[download]');
    downloadLinks.forEach((downloadLink) => {
        downloadLink.addEventListener('click', function(e) {
            e.preventDefault();
            let location = downloadLink.getAttribute('href');
            fetch(location)
            .then(resp => resp.status === 200 ? resp.blob() : Promise.reject('something went wrong'))
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = '';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch((e) => window.location = location);
        });
    });
});